import i18n from "@/i18n"
import { PointOfCarePurpose } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"
import {
  PointOfCareType,
  PointOfCareTypeValues,
  ReasonForChoosingType,
  ReasonForChoosingTypeValues,
  TimeToTreatType,
  TimeToTreatTypeValues,
} from "@/types/__generated__/union-types"

type OptionItem<T> = {
  label: string
  value: T
}

export const pointOfCareItems: OptionItem<PointOfCareType>[] = PointOfCareTypeValues.map((v: PointOfCareType) => ({
  label: i18n.t(`episodeOfCare.progressNote.pointOfCare.types.${v}`),
  value: v,
}))

export const reasonForChoosingItems: OptionItem<ReasonForChoosingType>[] = ReasonForChoosingTypeValues.map(
  (v: ReasonForChoosingType) => ({
    label: i18n.t(`episodeOfCare.progressNote.pointOfCare.reasonList.${v}`),
    value: v,
  }),
)

export const timeToTreatItems: OptionItem<TimeToTreatType>[] = TimeToTreatTypeValues.map((v: TimeToTreatType) => ({
  label: i18n.t(`episodeOfCare.progressNote.pointOfCare.timeToTreatOptionList.${v.toLowerCase()}`),
  value: v,
}))

type PurposeKeys = keyof NonNullable<PointOfCarePurpose>

export const getPurposeItems = (purpose?: PointOfCarePurpose): string[] => {
  if (purpose) {
    const purposeKeys = Object.keys(purpose) as PurposeKeys[]
    return purposeKeys
      .filter((key: PurposeKeys) => purpose[key])
      .map((item: PurposeKeys) => i18n.t(`episodeOfCare.progressNote.pointOfCare.purposeOptionList.${item}`))
  }
  return []
}
